export default __webpack_public_path__ + "static/media/n2.511ee439.jpg";